import React, {Fragment, useCallback} from 'react';
import {
  Box,
  Select,
  MenuItem,
  ListItem,
  FormControl,
  InputLabel
} from '@mui/material';

export const ArdDangerSignSelect = ({
  item,
  data: {key, value},
  callback,
  locationLocked
}) => {
  const handleChange = useCallback(
    e => {
      callback(item, {[key]: {value: e.target.value}});
    },
    [callback, value, key, item]
  );

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '30%'
      }}>
      <Box
        sx={{
          display: 'flex',
          width: '100%',
          height: '100%',
          justifyContent: 'center',
          alignItems: 'flex-end'
        }}>
        {locationLocked ? (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              alignItems: 'flex-end'
            }}>
            <FormControl
              sx={theme => ({
                '& .Mui-focused': {
                  color: theme.palette.secondary.main + ' !important'
                },
                '& .MuiInputBase-root': {
                  py: 0.5
                }
              })}
              fullWidth>
              <InputLabel
                id={`warning-sign-select-${item.id}`}
                sx={theme => ({
                  '&.Mui-focused': {
                    color: theme.palette.secondary.main + ' !important'
                  }
                })}>
                Warning sign ID
              </InputLabel>
              <Select
                label={'Warning sign ID'}
                labelId={`warning-sign-select-${item.id}`}
                fullWidth
                size={'small'}
                value={value}
                color={'secondary'}
                onChange={handleChange}
                sx={{
                  '& .MuiSelect-select': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: 0,
                    pl: 1,
                    '& .MuiListItemIcon-root': {
                      display: 'none'
                    }
                  },
                  '& > svg': {
                    right: 0
                  }
                }}>
                <MenuItem value={'X'}>
                  <em>none</em>
                </MenuItem>
                {[45, 46, 47, 48, 49, 50].map(iconId => (
                  <MenuItem component={ListItem} value={iconId} key={iconId}>
                    {iconId}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        ) : (
          <Fragment />
        )}
      </Box>
    </Box>
  );
};
export default ArdDangerSignSelect;
